// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2rhd5","row":"Node_row__2zkx_","label":"Node_label__34qPZ","footer":"Node_footer__4AJPu"};